import { useContext } from 'react'
import { MarkupContext } from '../../providers/Markup'
import { resolveCuratedTitleTag, stripSingleParagraphWrapper, getCuratedTitleClassName } from '../../helpers/markup'

/**
 * Renders a curated card title with semantic heading markup when the CMS
 * title is plain RTE copy (no existing h1–h6). Otherwise outputs the RTE as-is.
 */
export default function CuratedCardTitle({ title, useSmallTitle, titleAlignment, className = '' }) {
  const { createMarkup } = useContext(MarkupContext)
  const alignmentClass = titleAlignment ? `text-${titleAlignment.toLowerCase()}` : ''
  const titleTag = resolveCuratedTitleTag(title, useSmallTitle)
  const classes = getCuratedTitleClassName(titleTag, [className, alignmentClass].filter(Boolean).join(' '))

  if (!titleTag) {
    return (
      <div
        className={classes}
        data-rte="true"
        dangerouslySetInnerHTML={createMarkup(title)}
      />
    )
  }

  const TitleTag = titleTag

  return (
    <TitleTag
      className={classes}
      dangerouslySetInnerHTML={createMarkup(stripSingleParagraphWrapper(title))}
    />
  )
}
